module.exports = __webpack_public_path__ + "img/Crediscotia.2b1d92ce.svg";